import { EventActionType } from './event-action-type';

export interface SetEventOccurrenceStartsAt {
  type: EventActionType.SetOccurrenceStartsAt;
  eventKey: string;
  occurrenceIndex: number;
  startsAt: string;
}

export const setEventOccurrenceStartsAt = (
  eventKey: string,
  occurrenceIndex: number,
  startsAt: string | Date,
): SetEventOccurrenceStartsAt => ({
  eventKey,
  occurrenceIndex,
  startsAt: new Date(startsAt).toISOString(),
  type: EventActionType.SetOccurrenceStartsAt,
});
